/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Nocollaboratorsfounddescription3Inputs */

const en_settings_collaborators_nocollaboratorsfounddescription3 = /** @type {(inputs: Settings_Collaborators_Nocollaboratorsfounddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No collaborators with the search result were found`)
};

/**
* | output |
* | --- |
* | "No collaborators with the search result were found" |
*
* @param {Settings_Collaborators_Nocollaboratorsfounddescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nocollaboratorsfounddescription3 = /** @type {((inputs?: Settings_Collaborators_Nocollaboratorsfounddescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nocollaboratorsfounddescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nocollaboratorsfounddescription3(inputs)
});
export { settings_collaborators_nocollaboratorsfounddescription3 as "settings_collaborators_noCollaboratorsFoundDescription" }